var $ = require('jQuery');
var Vue = require('vue');
var Multiselect = require('vue-bootstrap').Multiselect;

module.exports = function()
{
    new Vue({
        el: '#webhook-subscription-events-selector',
        components: {
            'multiselect': Multiselect
        }
    });
};
